import React, { useState } from 'react';
import { LocationData } from '../types';

interface LocationInputProps {
    onLocationChange: (location: LocationData | undefined) => void;
    initialLocation?: LocationData;
}

export const LocationInput: React.FC<LocationInputProps> = ({ onLocationChange, initialLocation }) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [location, setLocation] = useState<LocationData | undefined>(initialLocation);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [error, setError] = useState<string | null>(null);

    React.useEffect(() => {
        // Silent auto-detect on mount
        if (!navigator.geolocation) {
            setError('Geolocation is not supported');
            return;
        }

        navigator.geolocation.getCurrentPosition(
            (position) => {
                const newLocation: LocationData = {
                    latitude: position.coords.latitude,
                    longitude: position.coords.longitude,
                    accuracy: position.coords.accuracy,
                };
                setLocation(newLocation);
                onLocationChange(newLocation);
            },
            (err) => {
                // Silently fail for permission denied, log other errors
                if (err.code !== err.PERMISSION_DENIED) {
                    console.error('Location detection error:', err.message);
                    setError(err.message);
                }
            },
            {
                enableHighAccuracy: true,
                timeout: 5000,
                maximumAge: 300000 // Accept cache from last 5 mins
            }
        );
    }, [onLocationChange]);

    // Render nothing visible, or perhaps a tiny indicator if location is found?
    // User requested "minimal status", let's show a small icon if location IS found.
    if (location) {
        return (
            <div title={`Location detected: ${location.latitude.toFixed(4)}, ${location.longitude.toFixed(4)}`} style={{ fontSize: '0.8rem', color: '#28a745', marginTop: '5px' }}>
                📍 Location detected
            </div>
        );
    }

    // Also show error if it's not permission denied? No, keep it clean as requested.
    return null;
};
